import { apiInstance } from 'src/utils/http'

const GET = 'get'
const POST = 'post'

const basenameReg = new RegExp(livecloud.basename)

function createApi(method, loading = true) {
  return (url) => {
    return async function (data) {
      let params, body
      if (method === GET) {
        params = data
      }
      else {
        if (Reflect.has(data, 'params') || Reflect.has(data, 'body')) {
          body = data.body
          params = data.params
        } else {
          body = data
        }
      }
      try {
        loading && livecloud.loading.show()
        return await apiInstance({
          method,
          url:  !basenameReg.test(url) ? `${livecloud.basename}${url}` : url,
          params,
          data: body
        })
      } catch (e) {
        console.log(e)
      }
      finally {
        loading && livecloud.loading.close()
      }
    }
  }
}

export const getApi = createApi(GET)
export const postApi = createApi(POST)
export const getApiNoLoading = createApi(GET, false)

/** 获取验证码url */
export function getCodeUrl() {
  return `${livecloud.basename}/liveid/captcha/generateCode?type=4&r=${Math.random()}`
}
